import React, { useState, useEffect } from "react";
import { Client, Databases, ID } from "appwrite";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import close from "../assets/Academy/close.webp";
import bgpink from "../assets/Academy/pinkbg.png";
import { 
  parsePhoneNumberFromString, 
  isValidPhoneNumber 
} from "libphonenumber-js";
import config from "../config/config";

const DownloadBrochure = ({ isOpen, onClose, utmContent, academyTitle, brochureUrl, academyBrochureImage }) => {
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [businessemail, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [describeyourbest, setDescribeyourbest] = useState("");
  const [otherDescription, setOtherDescription] = useState(""); 
  const [areaofinterest, setAreaofInterest] = useState("");
  const [otherInterest, setOtherInterest] = useState(""); // New state for "Other" interest
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [interestDropdownOpen, setInterestDropdownOpen] = useState(false);

  const describeOptions = [
    "I'm interested in self paced courses",
    "I'm interested in workshops for corporates",
    "Other"
  ];

  const interestOptions = [
    "Artificial Intelligence Courses",
    "Journey Mapping Workshop",
    "Data Visualisation Workshop",
    "Product Management",
    "Data and Analytics",
    "Service Design",
    "Customer Experience",
    "Others" // Changed from "Others" to match the pattern from describeyourbest
  ];

  const [utmParams, setUtmParams] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_id: "",
    utm_term: "",
    utm_content: "",
  });

  const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

  const databases = new Databases(client);

  useEffect(() => {
    const captureUtmParams = () => {
      const params = new URLSearchParams(window.location.search);
      const utmFields = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id",
        "utm_term",
      ];

      const newUtmParams = {
        utm_content: utmContent,
      };
      utmFields.forEach((field) => {
        newUtmParams[field] = params.get(field) || "";
      });
      
      setUtmParams(newUtmParams);
    };

    captureUtmParams();
    window.addEventListener("popstate", captureUtmParams);

    return () => {
      window.removeEventListener("popstate", captureUtmParams);
    };
  }, [utmContent]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const describeDropdown = document.getElementById("describe-dropdown-container");
      const interestDropdown = document.getElementById("interest-dropdown-container");
      
      if (describeDropdown && !describeDropdown.contains(event.target)) {
        setDropdownOpen(false);
      }
      
      if (interestDropdown && !interestDropdown.contains(event.target)) {
        setInterestDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePhoneNumberChange = (number, country) => {
    setPhoneNumber(number);

    try {
      const fullNumber = number.startsWith("+") ? number : `+${number}`;

      if (isValidPhoneNumber(fullNumber)) {
        const phoneNumberObj = parsePhoneNumberFromString(fullNumber);
        const nationalNumber = phoneNumberObj.nationalNumber;

        const expectedLength = phoneNumberObj.nationalNumber?.length;
        const actualLength = nationalNumber?.length;

        if (actualLength < expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too short - needs ${expectedLength} digits`,
          }));
        } else if (actualLength > expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too long - should be ${expectedLength} digits`,
          }));
        } else {
          setErrors((prev) => ({ ...prev, phoneNumber: "" }));
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
      }
    } catch (error) {
      console.error("Phone validation error:", error);
      setErrors((prev) => ({
        ...prev,
        phoneNumber: "Please enter a valid phone number",
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      if (!phoneNumber) {
        setErrors({ phoneNumber: "Phone number is required" });
        setIsLoading(false);
        return;
      }

      if (!describeyourbest) {
        setErrors((prev) => ({
          ...prev,
          describeyourbest: "Please select an option",
        }));
        setIsLoading(false);
        return;
      }

      // Validate other description if "Other" is selected
      if (describeyourbest === "Other" && !otherDescription) {
        setErrors((prev) => ({
          ...prev,
          otherDescription: "Please describe your interest",
        }));
        setIsLoading(false);
        return;
      }

      if (!areaofinterest) {
        setErrors((prev) => ({
          ...prev,
          areaofinterest: "Please select an area of interest",
        }));
        setIsLoading(false);
        return;
      }

      // Validate other interest if "Others" is selected
      if (areaofinterest === "Others" && !otherInterest) {
        setErrors((prev) => ({
          ...prev,
          otherInterest: "Please describe your area of interest",
        }));
        setIsLoading(false);
        return;
      }

      const fullNumber = phoneNumber.startsWith("+") 
        ? phoneNumber 
        : `+${phoneNumber}`;

      if (!isValidPhoneNumber(fullNumber)) {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
        setIsLoading(false);
        return;
      }

      const formData = {
        firstname,
        lastname,
        businessemail,
        phoneNumber,
        describeyourbest: describeyourbest === "Other" ? `Other: ${otherDescription}` : describeyourbest,
        areaofinterest: areaofinterest === "Others" ? `Others: ${otherInterest}` : areaofinterest,
        otherDescription: describeyourbest === "Other" ? otherDescription : "",
        otherInterest: areaofinterest === "Others" ? otherInterest : "",
        utmSource: utmParams.utm_source,
        utmMedium: utmParams.utm_medium,
        utmCampaign: utmParams.utm_campaign,
        utmId: utmParams.utm_id,
        utmTerm: utmParams.utm_term,
        utmContent: utmParams.utm_content,
      };

      await Promise.all([
        databases.createDocument(
          process.env.REACT_APP_DATABASE_ID,
          config.collectionIds.academyBrochure,  
          ID.unique(),
          formData
        ),
      ]);

      window.open(brochureUrl, '_blank');

      setIsSuccessOpen(true);
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ submit: "Failed to submit form. Please try again." });
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setDescribeyourbest("");
    setOtherDescription("");
    setAreaofInterest("");
    setOtherInterest("");
    setErrors({});
  };

  const closeSuccessModal = () => {
    setIsSuccessOpen(false);
    onClose();
  };

  if (!isOpen) return null;

  // Default image placeholder in case academyBrochureImage is not provided
  const imageUrl = academyBrochureImage?.url;

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg p- w-11/12 md:w-full max-w-4xl relative flex">
          <button onClick={onClose} className="absolute top-4 right-4">
            <img src={close} alt="Close" className="w-3 h-3" />
          </button>
          <div className="hidden md:block w-full">
            <div className="hidden md:block w-5/6 px-8 py-10 p-2 flex justify-center items-center relative">
              {/* Background image positioned absolutely */}
              <div className="absolute inset-0 p-2">
                <img src={bgpink} alt="Background" className="w-full h-full object-cover rounded-lg transform -translate-x-1 " />
              </div>
              {/* Main image */}
              <div className="flex justify-center items-center w-full">
                <img src={imageUrl} alt="Download Brochure" className="h-full rounded-lg relative z-10 transform translate-x-6 shadow-2xl" />
              </div>
            </div>
          </div>
          <div className="md:w-4/5 p-5">
            <h2 className="text-base font-semibold mb-0">
              Download Brochure
            </h2>
            <h2 className="text-sm font-normal mb-2">
              Get detailed information on what to expect from our online courses 
            </h2>
            <form onSubmit={handleSubmit} className="space-y-2">
              <div className="mb-0">
                <label className="text-gray-700">First Name</label>
                <input
                  id="firstname"
                  type="text"
                  name="firstname"
                  value={firstname}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="w-full px-3 py-2 border rounded"
                  required
                />
                {errors.firstname && (
                  <p className="text-red-500 text-sm">{errors.firstname}</p>
                )}
              </div>
              <div className="mb-0">
                <label className="text-gray-700">Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  id="lastname"
                  value={lastname}
                  onChange={(e) => setLastName(e.target.value)}
                  className="w-full px-3 py-2 border rounded"
                  required
                />
                {errors.lastname && (
                  <p className="text-red-500 text-sm">{errors.lastname}</p>
                )}
              </div>
        
              <div className="mb-0">
                <label className="text-gray-700">Business Email</label>
                <input
                  id="businessemail"
                  type="email"
                  name="businessemail"
                  value={businessemail}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border rounded"
                  required
                />
                {errors.businessemail && (
                  <p className="text-red-500 text-sm">
                    {errors.businessemail}
                  </p>
                )}
              </div>
              <div className="mb-0">
                <label id="Phonenumber" className="text-gray-700">
                  Phone Number
                </label>
                <PhoneInput
                  country={"in"}
                  value={phoneNumber}
                  onChange={(number, country) =>
                    handlePhoneNumberChange(number, country)
                  }
                  inputClass="custom-phone-input2 "
                  buttonClass="border rounded"
                  dropdownClass="border rounded"
                  required
                  enableSearch={true}
                  inputProps={{
                    required: true,
                    autoFocus: false,
                  }}
                />
                {errors.phoneNumber && (
                  <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
                )}
              </div>
             
              <div className="mb-0" id="describe-dropdown-container">
                <label className="text-gray-700">What describes you the best?</label>
                {describeyourbest === "Other" ? (
                  <div className="relative">
                    <textarea
                      name="otherDescription"
                      value={otherDescription}
                      onChange={(e) => setOtherDescription(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                      rows="3"
                      placeholder="Please describe your interest..."
                      required
                    />
                    {errors.otherDescription && (
                      <p className="text-red-500 text-sm">{errors.otherDescription}</p>
                    )}
                    <button
                      type="button"
                      className="mt-1 text-blue-600 hover:text-blue-800 text-sm"
                      onClick={() => {
                        setDescribeyourbest("");
                        setOtherDescription("");
                      }}
                    >
                      Change selection
                    </button>
                  </div>
                ) : (
                  <div className="relative">
                    <button
                      type="button"
                      className="w-full px-3 py-2 border rounded flex justify-between items-center"
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                    >
                      {describeyourbest || "Select an option"}
                      <svg 
                        className={`w-4 h-4 ml-2 transform ${dropdownOpen ? 'rotate-180' : ''}`}
                        fill="currentColor" 
                        viewBox="0 0 20 20"
                      >
                        <path 
                          fillRule="evenodd" 
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                    
                    {dropdownOpen && (
                      <div className="absolute z-10 w-full bottom-full mb-1 bg-white border rounded shadow-lg text-gray-700">
                        {describeOptions.map((option, index) => (
                          <div 
                            key={index}
                            className="px-3 py-2 cursor-pointer text-gray-700 hover:bg-[#B4BDFF]"
                            onClick={() => {
                              setDescribeyourbest(option);
                              setDropdownOpen(false);
                              setErrors((prev) => ({ ...prev, describeyourbest: "" }));
                            }}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                    {errors.describeyourbest && (
                      <p className="text-red-500 text-sm">{errors.describeyourbest}</p>
                    )}
                  </div>
                )}
              </div>
              
              <div className="mb-4" id="interest-dropdown-container">
                <label className="text-gray-700">Area of interest</label>
                {areaofinterest === "Others" ? (
                  <div className="relative">
                    <textarea
                      name="otherInterest"
                      value={otherInterest}
                      onChange={(e) => setOtherInterest(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                      rows="3"
                      placeholder="Please describe your area of interest..."
                      required
                    />
                    {errors.otherInterest && (
                      <p className="text-red-500 text-sm">{errors.otherInterest}</p>
                    )}
                    <button
                      type="button"
                      className="mt-1 text-blue-600 hover:text-blue-800 text-sm"
                      onClick={() => {
                        setAreaofInterest("");
                        setOtherInterest("");
                      }}
                    >
                      Change selection
                    </button>
                  </div>
                ) : (
                  <div className="relative">
                    <button
                      type="button"
                      className="w-full px-3 py-2 border rounded flex justify-between items-center"
                      onClick={() => setInterestDropdownOpen(!interestDropdownOpen)}
                    >
                      {areaofinterest || "Select your area of interest"}
                      <svg 
                        className={`w-4 h-4 ml-2 transform ${interestDropdownOpen ? 'rotate-180' : ''}`}
                        fill="currentColor" 
                        viewBox="0 0 20 20"
                      >
                        <path 
                          fillRule="evenodd" 
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                    
                    {interestDropdownOpen && (
                      <div className="absolute z-10 w-full bottom-full mb-1 bg-white border rounded shadow-lg text-gray-700">
                        {interestOptions.map((option, index) => (
                          <div 
                            key={index}
                            className="px-3 py-2 cursor-pointer text-gray-700 hover:bg-[#B4BDFF]"
                            onClick={() => {
                              setAreaofInterest(option);
                              setInterestDropdownOpen(false);
                              setErrors((prev) => ({ ...prev, areaofinterest: "" }));
                            }}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                {errors.areaofinterest && (
                  <p className="text-red-500 text-sm">{errors.areaofinterest}</p>
                )}
              </div>
            
              <button 
                type="submit" 
                className={`w-full p-2 bg-[rgba(62,89,183,1)] text-white rounded hover:bg-blue-700 ${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Download Brochure"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {isSuccessOpen && (
        <section className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="relative bg-white p-8 rounded-lg max-w-md md:w-full text-center">
            <a
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={closeSuccessModal}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </a>
            <h2 className="text-2xl font-bold mb-4">Success!</h2>
            <p className="mb-4">Your brochure is being downloaded.</p>
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded"
              onClick={closeSuccessModal}
            >
              Close
            </button>
          </div>
        </section>
      )}
    </>
  );
};

export default DownloadBrochure;